import React, { useRef, useState, useEffect } from "react";
import WaveSurfer from "wavesurfer.js";
import "./CodeEditor/editor.scss";

const WaveformPlayer = ({ audioUrl , onLoadingChange , hideDownload , onError }) => {
  const waveformRef = useRef(null);
  const wavesurfer = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    onLoadingChange?.(true);
    const timeout = setTimeout(() => {
      wavesurfer.current = WaveSurfer.create({
        container: waveformRef.current,
        waveColor: "#ccc",
        progressColor: "#000000",
        cursorColor: "blue", // hide default cursor
        height: 50,
        barWidth: 2,
        barRadius: 2,
        responsive: true,
      });

      wavesurfer.current.load(audioUrl);

      // Set up events as before...
      wavesurfer.current.on("ready", () => {
        setDuration(wavesurfer.current.getDuration());
        onLoadingChange?.(false);
      });

      wavesurfer.current.on("error", (e) => {
        console.error("WaveSurfer load error:", e);
        onLoadingChange?.(false);
        onError?.(e);
      });
    }, 100); // Delay of 100ms to ensure rendering

    return () => {
      clearTimeout(timeout);
      if (wavesurfer.current) wavesurfer.current.destroy();
    };
  }, [audioUrl]);

  const handlePlayPause = () => {
    wavesurfer.current.playPause();
    setPlaying(!playing);
  };

  // Helper to format time in mm:ss format.
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleDownload = async (url,) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", "interview-audio.wav"); // or use dynamic filename
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl); // clean up
    } catch (err) {
      console.error("Error downloading audio:", err);
    }
  };

  return (
    <div className="voice-player" style={{ position: "relative" }}>
      {/* Play/Pause Button positioned in the center of the waveform */}
      <button onClick={handlePlayPause}>
        {playing ? "⏸" : "▶"}
      </button>

      {/* Waveform container */}
      <div
        id="waveform"
        ref={waveformRef}
      ></div>

      {/* Display the total audio duration at the end of the waveform */}
      <div
        style={{
          padding: "2px 4px",
          borderRadius: "4px",
          fontSize: "14px",
        }}
      >
        {formatTime(duration)}&nbsp;
      </div>
       {!hideDownload && (
        <img
          src="/images/download.svg"
          alt="Download"
          onClick={() => handleDownload(audioUrl)}
          style={{ width: "20px", height: "20px", cursor: "pointer", marginLeft: "8px" }}
        />
      )}
    </div>
  );
};

export default WaveformPlayer;
